import { ReactNode, useState } from "react";
import { Modal } from "rsuite";

interface ModalPopupProps {
  title: string;
  children: ReactNode;
  visible: boolean;
  handleClose?: () => void;
}

const ModalPopup: React.FC<ModalPopupProps> = ({
  title,
  visible,
  children,
  handleClose = () => {},
}) => {
  return (
    <div className="common-modal">
      {" "}
      <Modal
        onClose={() => {
          handleClose();
        }}
        size={"30rem"}
        open={visible}
      >
        <Modal.Header>
          <Modal.Title className="text-fs16">{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{children}</Modal.Body>
      </Modal>
    </div>
  );
};

export default ModalPopup;
